export default __webpack_public_path__ + "static/ball-98039e998122b05005ed87128257c33e.mp4";